import { City } from "../../hooks/useCities";
import { State } from "../../hooks/useStates";

export function formatWeatherTitle(
  selectedCity: number | undefined,
  selectedState: number | undefined,
  cityData: City[],
  stateData: State[]
) {
  const cidade = cityData.find((c) => c.ib === selectedCity)?.n;
  const estado = stateData.find((s) => s.codigo_uf === selectedState)?.nome;

  if (cidade && estado) {
    return `Previsão do Tempo - ${estado} - ${cidade} `;
  }

  if (cidade) {
    return `Previsão do Tempo - ${cidade}`;
  }

  if (estado) {
    return `Previsão do Tempo - ${estado}`;
  }

  return 'Previsão do Tempo';
}